import 'slick-carousel'
import arrow from '../../images/arrow.svg'

export default function homeCarousel() {
  $('.home-study-type-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" /></button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" /></button>`,
    responsive:[
      {
        breakpoint: 1245,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        }
      }
    ]
  });
}
